export const formatDateWithNumbersAndDays = (dateString: string) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('ru-RU', {
    weekday: 'short',
    day: 'numeric',
    month: 'numeric',
  });
  return formattedDate;
};
